<template>
  <div
  >
    <v-menu
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-if="replace_status_with_displayName"
          v-bind="attrs"
          v-on="on"
        >
         {{engine.display_name}}
        </div>
        <div
          v-else
          :class="get_status_color +  ' px-3'"
          v-bind="attrs"
          v-on="on"
        >
          {{engine.status}}
        </div>
      </template>
      <v-card>
        <v-card-title>
          {{engine.display_name}}
          <v-chip
            class="ml-2 primary"
            x-small
            @click="$router.push({path: '/sds', query: {issi: engine.issi}})"
          >
            {{engine.issi}}
          </v-chip>
          <v-spacer></v-spacer>
          <v-icon
            v-if="engine.visualize_alarm"
            class="mx-2 float-right"
            color="red"
            large
          >
            mdi-alarm
          </v-icon>
          <div
            :class="get_status_color +  ' px-3'"
            style="float: right"
          >
            {{ engine.status }}
          </div>
        </v-card-title>
        <v-card-subtitle>
          Geändert: {{ last_status_timestamp }}
        </v-card-subtitle>
        <v-card-text>
          <v-chip
            v-for="(tag, index) in engine.tags"
            :key="index"
            class="mr-1"
          >
            {{tag}}
          </v-chip>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
        >
          Status korrigieren:
          <v-btn
            v-for="(status, index) in [1,2,3,4,6]"
            :key="index"
            class="ml-1"
            :color="status_color_table[status]"
            :disabled="($store.state.user.pms !== null && $store.state.user.pms.includes('SFW_ELOCOM_Status_rw')) ?  false : true"
            @click="send_status(status)"
          >
            {{ status }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "Status",
  props: ["engine", "replace_status_with_displayName"],
  data: () => ({
    status_color_table: {
      "0": "red",
      "1": "light-green",
      "2": "green darken-3",
      "3": "orange",
      "4": "primary",
      "6": "grey",
      "7": "pink accent-2",
      "8": "purple darken-2",
    },
  }),
  computed: {
    last_status_timestamp(){
      let unix_timestamp = this.engine.status_timestamp;
      let date = new Date(unix_timestamp * 1000)
      return date.toLocaleDateString() + " - " + date.toLocaleTimeString() + " Uhr";
    },
    get_status_color(){
      if(this.engine.status in this.status_color_table){
        return this.status_color_table[this.engine.status]
      }
      return "purple"
    },
  },
  methods: {
    send_status(status){
      this.$store.dispatch("update", { "payload_type": "PUT", "context": "/engines/" + this.engine.issi + "/" + status })
    }
  }
};
</script>

<style scoped>

</style>
